/**
 * @generated SignedSource<<4fff563112aca03e5a02a0d8e1aab78c>>
 * @relayHash f012cd6ea0b0e97d790644cd592d7ac5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd7f958d60d0b22d9dded72d13f42c04a9a523af970e1888881c582d046ce936

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AvailabilityPageQuery } from './AvailabilityPageQuery.graphql';

const node: PreloadableConcreteRequest<AvailabilityPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bd7f958d60d0b22d9dded72d13f42c04a9a523af970e1888881c582d046ce936",
    "metadata": {},
    "name": "AvailabilityPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
